module.exports = __webpack_public_path__ + "static/media/PC.767f32a6.png";